import React, { useEffect, useState } from 'react';
import { getOrders } from '../api';
import { Link } from 'react-router-dom';

function OrdersPage() {
    const token = localStorage.getItem('token');
    const [orders, setOrders] = useState([]);
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const fetchOrders = async (showLoader = true) => {
        setMessage('');

        if (showLoader) {
            setIsLoading(true);
        }

        const data = await getOrders(token);

        if (Array.isArray(data)) {
            setOrders(data);
        } else if (data && Array.isArray(data.orders)) {
            setOrders(data.orders);
        } else {
            setOrders([]);
            setMessage(data.message || 'Не удалось загрузить список заказов');
        }

        if (showLoader) {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchOrders();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const hasProcessingOrders = orders.some(
            (order) => order.status === 'Обработка данных'
        );

        if (!hasProcessingOrders) {
            return;
        }

        const intervalId = setInterval(() => {
            fetchOrders(false);
        }, 2000);

        return () => clearInterval(intervalId);
        // eslint-disable-next-line
    }, [orders]);

    const getStatusLabelStyle = (status) => {
        const value = (status || '').toLowerCase();

        if (value.includes('обработка')) {
            return {
                background: '#fef3c7',
                color: '#92400e'
            };
        }

        if (value.includes('заплан')) {
            return {
                background: '#dbeafe',
                color: '#1d4ed8'
            };
        }

        if (value.includes('передано')) {
            return {
                background: '#ede9fe',
                color: '#6d28d9'
            };
        }

        if (value.includes('created')) {
            return {
                background: '#fef3c7',
                color: '#92400e'
            };
        }

        return {
            background: '#e5e7eb',
            color: '#374151'
        };
    };

    const renderItems = (items) => {
        if (!items || !items.length) {
            return (
                <div style={{ color: '#9ca3af' }}>
                    Состав заказа недоступен
                </div>
            );
        }

        return items.map((item, index) => (
            <div
                key={index}
                style={{
                    padding: '8px 0',
                    borderBottom: index !== items.length - 1 ? '1px solid #f3f4f6' : 'none',
                    color: '#374151'
                }}
            >
                <strong>{item.name}</strong> — {item.quantity} шт. × {item.price} руб.
            </div>
        ));
    };

    return (
        <div style={{ padding: '24px' }}>
            <div style={{ maxWidth: '1150px', margin: '0 auto' }}>
                <div
                    style={{
                        background: 'linear-gradient(135deg, #ffffff 0%, #eef4ff 100%)',
                        borderRadius: '20px',
                        padding: '28px',
                        boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
                        marginBottom: '20px'
                    }}
                >
                    <h2 style={{ margin: '0 0 10px 0', fontSize: '2rem', color: '#111827' }}>
                        Мои заказы
                    </h2>
                    <p style={{ margin: 0, color: '#6b7280' }}>
                        Здесь отображаются заказы пользователя и их текущие статусы.
                    </p>
                </div>

                {isLoading && (
                    <div
                        style={{
                            background: '#fff',
                            borderRadius: '18px',
                            padding: '22px',
                            boxShadow: '0 10px 24px rgba(15, 23, 42, 0.06)',
                            color: '#6b7280'
                        }}
                    >
                        Загрузка заказов...
                    </div>
                )}

                {!isLoading && message && (
                    <div
                        style={{
                            background: '#fff7ed',
                            border: '1px solid #fdba74',
                            color: '#9a3412',
                            borderRadius: '16px',
                            padding: '16px',
                            marginBottom: '18px'
                        }}
                    >
                        {message}
                    </div>
                )}

                {!isLoading && !message && orders.length === 0 && (
                    <div
                        style={{
                            background: '#fff',
                            borderRadius: '18px',
                            padding: '22px',
                            boxShadow: '0 10px 24px rgba(15, 23, 42, 0.06)',
                            color: '#6b7280'
                        }}
                    >
                        У вас пока нет заказов.
                    </div>
                )}

                {!isLoading && orders.length > 0 && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
                        {orders.map((order, index) => {
                            const orderId = order.order_id || order.id || index + 1;

                            return (
                                <div
                                    key={orderId}
                                    style={{
                                        background: '#ffffff',
                                        borderRadius: '20px',
                                        padding: '22px',
                                        boxShadow: '0 10px 24px rgba(15, 23, 42, 0.06)',
                                        border: '1px solid #eef2f7'
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'flex-start',
                                            gap: '16px',
                                            flexWrap: 'wrap',
                                            marginBottom: '16px'
                                        }}
                                    >
                                        <div>
                                            <div style={{ fontSize: '1.2rem', fontWeight: '800', color: '#111827' }}>
                                                Заказ №{orderId}
                                            </div>
                                            <div style={{ color: '#6b7280', marginTop: '6px' }}>
                                                Дата: {order.created_at || 'Не указана'}
                                            </div>
                                            <div style={{ color: '#111827', marginTop: '6px', fontWeight: '700' }}>
                                                Сумма: {order.total_price || 0} руб.
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                ...getStatusLabelStyle(order.status),
                                                padding: '10px 14px',
                                                borderRadius: '999px',
                                                fontWeight: '700',
                                                fontSize: '0.95rem'
                                            }}
                                        >
                                            {order.status || 'Статус не указан'}
                                        </div>
                                    </div>

                                    <div
                                        style={{
                                            background: '#f9fafb',
                                            borderRadius: '14px',
                                            padding: '14px',
                                            marginBottom: '16px'
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontWeight: '700',
                                                color: '#111827',
                                                marginBottom: '8px'
                                            }}
                                        >
                                            Товары в заказе
                                        </div>
                                        {renderItems(order.items)}
                                    </div>

                                    <Link
                                        to={`/order/${orderId}`}
                                        style={{
                                            display: 'inline-block',
                                            textDecoration: 'none',
                                            background: '#111827',
                                            color: '#fff',
                                            padding: '11px 16px',
                                            borderRadius: '12px',
                                            fontWeight: '700'
                                        }}
                                    >
                                        Открыть заказ
                                    </Link>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}

export default OrdersPage;